export type IconProps = React.HTMLAttributes<SVGElement>;

export const ThumbaCoin = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none" {...props}>
      <g clip-path="url(#clip0_18360_56070)">
        <path
          d="M10.859 20.3015C16.3501 20.3015 20.8015 15.8501 20.8015 10.3591C20.8015 4.86799 16.3501 0.416595 10.859 0.416595C5.3679 0.416595 0.916504 4.86799 0.916504 10.3591C0.916504 15.8501 5.3679 20.3015 10.859 20.3015Z"
          fill="#FFDD15"
        />
        <path
          d="M18.1712 3.61062C18.124 3.56344 18.0764 3.51761 18.0285 3.47156C21.7713 7.36443 21.7253 13.5542 17.8894 17.3898C14.0536 21.2256 7.86384 21.2714 3.97119 17.5289C4.01702 17.5767 4.06308 17.6243 4.11025 17.6715C7.99302 21.5543 14.2884 21.5543 18.1712 17.6715C22.0539 13.7888 22.0539 7.49339 18.1712 3.61062Z"
          fill="#D87D13"
        />
        <path
          d="M10.859 0.416595C5.36788 0.416595 0.916504 4.86797 0.916504 10.3591H20.8017C20.8017 4.86797 16.3503 0.416595 10.859 0.416595Z"
          fill="#FFEE71"
        />
        <path
          d="M10.8591 18.6364C15.4304 18.6364 19.1362 14.9306 19.1362 10.3593C19.1362 5.78802 15.4304 2.08224 10.8591 2.08224C6.28781 2.08224 2.58203 5.78802 2.58203 10.3593C2.58203 14.9306 6.28781 18.6364 10.8591 18.6364Z"
          fill="#FABF03"
        />
        <path
          d="M10.8591 2.08224C6.28777 2.08224 2.58203 5.78798 2.58203 10.3593H19.136C19.136 5.78798 15.4302 2.08224 10.8589 2.08224H10.8591Z"
          fill="#F7C908"
        />
        <path
          d="M2.86353 10.6408C2.86353 6.06948 6.56927 2.36374 11.1406 2.36374C13.3546 2.36374 15.3655 3.23294 16.851 4.64896C15.3435 3.0676 13.2165 2.08224 10.8591 2.08224C6.28777 2.08224 2.58203 5.78798 2.58203 10.3593C2.58203 12.7167 3.56738 14.8437 5.14875 16.3512C3.73296 14.866 2.86353 12.8551 2.86353 10.6408Z"
          fill="#D87D13"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.45154 8.35798L7.74448 9.02485L13.7765 14.6979L12.6237 15.7859L6.5913 10.1125L5.3262 11.3057C5.29722 11.333 5.24777 11.3298 5.22219 11.2976L4.35774 10.1186C4.33898 10.0929 4.34239 10.0591 4.36626 10.0382L5.43713 9.02699L5.43662 9.02651L6.58942 7.93853L6.58959 7.93869L7.29553 7.27206L8.44984 8.35798H8.45154ZM10.4276 7.3633L8.52435 9.15956L9.67916 10.2456L11.5824 8.44939L10.4276 7.3633ZM11.8988 8.74815L9.99558 10.5444L11.1504 11.6305L13.0537 9.83424L11.8988 8.74815ZM11.4673 11.9284L14.7883 8.794L15.9431 9.88009L12.6221 13.0144L11.4673 11.9284ZM16.2609 10.1788L12.9398 13.3132L14.0946 14.3993L17.4157 11.2649L16.2609 10.1788Z"
          fill="#D87D13"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.45154 7.80475L7.74448 8.47163L13.7765 14.1447L12.6237 15.2327L6.5913 9.55926L5.3262 10.7525C5.29722 10.7798 5.24777 10.7766 5.22219 10.7444L4.35774 9.56534C4.33898 9.53964 4.34239 9.50591 4.36626 9.48502L5.43713 8.47377L5.43662 8.47329L6.58942 7.3853L6.58959 7.38547L7.29553 6.71884L8.44984 7.80475H8.45154ZM10.4276 6.81008L8.52435 8.60633L9.67916 9.69242L11.5824 7.89617L10.4276 6.81008ZM11.8988 8.19492L9.99558 9.99118L11.1504 11.0773L13.0537 9.28101L11.8988 8.19492ZM11.4673 11.3751L14.7883 8.24078L15.9431 9.32687L12.6221 12.4612L11.4673 11.3751ZM16.2609 9.62563L12.9398 12.76L14.0946 13.8461L17.4157 10.7117L16.2609 9.62563Z"
          fill="#D87D13"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.45154 7.80475L7.74448 8.47163L13.7765 14.1447L12.6237 15.2327L6.5913 9.55926L5.3262 10.7525C5.29722 10.7798 5.24777 10.7766 5.22219 10.7444L4.35774 9.56534C4.33898 9.53964 4.34239 9.50591 4.36626 9.48502L5.43713 8.47377L5.43662 8.47329L6.58942 7.3853L6.58959 7.38547L7.29553 6.71884L8.44984 7.80475H8.45154ZM10.4276 6.81008L8.52435 8.60633L9.67916 9.69242L11.5824 7.89617L10.4276 6.81008ZM11.8988 8.19492L9.99558 9.99118L11.1504 11.0773L13.0537 9.28101L11.8988 8.19492ZM11.4673 11.3751L14.7883 8.24078L15.9431 9.32687L12.6221 12.4612L11.4673 11.3751ZM16.2609 9.62563L12.9398 12.76L14.0946 13.8461L17.4157 10.7117L16.2609 9.62563Z"
          fill="url(#paint0_linear_18360_56070)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_18360_56070"
          x1="10.8807"
          y1="6.71884"
          x2="10.8807"
          y2="15.2329"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.455" stop-color="#FFEE71" />
          <stop offset="0.4551" stop-color="#FFDD15" />
        </linearGradient>
        <clipPath id="clip0_18360_56070">
          <rect width="20.1667" height="20.1667" fill="white" transform="translate(0.916504 0.416595)" />
        </clipPath>
      </defs>
    </svg>
  );
};
